module.exports = __webpack_public_path__ + "static/media/aleks.9cdb0739.png";